export default __webpack_public_path__ + "static/media/contestacao.36fe11dd.png";